import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export const getPositionFromObjectAttribute = (attribute: CmdbObjectAttribute): number =>
	attribute.objectTypeAttribute?.position ?? Infinity;
